import React from 'react';
import { useTranslation } from 'react-i18next';
import './UrpassTickets.css';
import { IonItem } from '@ionic/react';
import UrpassTicket from './UrpassTicket';
import UrpassTicketToggle from './UrpassTicketToggle';
import { UrpassTicketType } from '../../services/types/urpassapitypes';

type UrpassTicketsProps = {
  activeTickets: UrpassTicketType[] | undefined;
  availableTickets: UrpassTicketType[] | undefined;
  expiredTickets: UrpassTicketType[] | undefined;
  activateTicket?: (t: any) => void;
  viewTicket?: (t: any) => void;
};

export default function UrpassTickets({
  activeTickets,
  availableTickets,
  expiredTickets,
  activateTicket,
  viewTicket,
}: UrpassTicketsProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <IonItem
        lines="none"
        className="ion-no-padding ion-pt-1 pseudo-select pseudo-select-highlighted"
      >
        <strong>{t('urpass.active')}</strong>
      </IonItem>
      {!activeTickets || activeTickets.length == 0 ? (
        <p className="pt-1 instructions ion-text-center">
          {t('urpass.noactive')}
        </p>
      ) : (
        <>
          {activeTickets.map((ticket: any) => {
            return (
              <UrpassTicket
                key={ticket.id}
                ticket={ticket}
                viewTicket={viewTicket}
              />
            );
          })}
        </>
      )}
      <UrpassTicketToggle
        highlight={true}
        title={t('urpass.inactive')}
        tickets={availableTickets}
        activateTicket={activateTicket}
      />
      <UrpassTicketToggle
        title={t('urpass.expired')}
        tickets={expiredTickets}
      />
    </>
  );
}
